// eslint-disable-next-line jira/import-whitelist
import { fetchIssueForgeData } from '@atlassian/jira-issue-fetch-services/src/services/issue-forge-data/index.tsx';
import { createResourceError } from '@atlassian/jira-router-resources-utils/src/utils/create-resource-error/index.tsx';
import { getIssueKey } from '@atlassian/jira-router-resources-utils/src/utils/get-issue-key/index.tsx';
import type { RouterDataContext, ResourceStoreContext } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async ({ match }: RouterDataContext, { tenantContext }: ResourceStoreContext) => {
	const issueKey = getIssueKey(match);

	if (!issueKey) {
		return null;
	}

	try {
		const { cloudId, isAnonymous } = tenantContext;
		const data = await fetchIssueForgeData(cloudId, issueKey, isAnonymous);
		return data;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		throw createResourceError(
			{
				component: 'spa.view.routes.issue-view.forge.getData',
				message: 'An error was thrown while prefetching issue Forge data',
				name: 'ResourceError',
			},
			error,
		);
	}
};
